module.exports = __webpack_public_path__ + "static/img/dfg_logo_schriftzug_blau_foerderung_4c.92dcd68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dfg_logo_schriftzug_blau_foerderung_4c.png
// module id = 910
// module chunks = 1